module.exports = __webpack_public_path__ + "432ee1e7680de7bef0b883bba0f10ddb.png";